import { Injectable } from '@angular/core';

import { Header, HeaderAlignmentKeys } from './header-alignment.interface';

const DESKTOP_DEFAULT_TITLE_ALIGNMENT = 'center';
const MOBILE_DEFAULT_TITLE_ALIGNMENT = 'left';

@Injectable({
    providedIn: 'root',
})
export class HeaderAlignmentService {
    constructor() { }

    getHeaderAlignment(data: any = {}): Header {
        const headerKeys = ['title', 'subtitle', 'headerLink'];

        return headerKeys.reduce((aggregate, key) => {
            // If there is no value for the header don't bother proceeding
            if (!data[key]) {
                return aggregate;
            }

            // Set the header value
            aggregate[key] = data[key];

            // For mobile we need to init/start/title cap the key name: e.g. `mobileTitleAlignment`
            const keyCap = key.charAt(0).toUpperCase() + key.slice(1);

            // Set alignment values - use the existing value (if applicable) or the default
            // The helper function allows us to restrict values to only ones we want
            [`${key}Alignment`, `mobile${keyCap}Alignment`].forEach(alignment => {
                aggregate[alignment] = this.setAlignment(data[alignment], alignment);
            });

            return aggregate;
        }, {});
    }


    private setAlignment(alignment: string, titleName: string): string {
        // Desktop alignment should always be center
        let defaultAlignment = DESKTOP_DEFAULT_TITLE_ALIGNMENT;

        // We want mobile to default align to the left
        if (titleName.includes('mobile')) {
            defaultAlignment = MOBILE_DEFAULT_TITLE_ALIGNMENT;
        }

        return Object.keys(HeaderAlignmentKeys).includes(alignment) ?
            alignment :
            defaultAlignment;
    }
}
